var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"material-icons modal-btn",attrs:{"variant":"success","size":_vm.size},on:{"click":function($event){return _vm.touch()}}},[_vm._v(" add_circle_outline ")])}
var staticRenderFns = []

export { render, staticRenderFns }